<template lang="pug">
#modal-create-user
    //- Button
    button.btn.btn-primary(v-if="accountActive", @click="showModal = true")
        font-awesome-icon.mr-2(icon="plus")
        span.d-none.d-sm-inline Neuen Benutzer hinzufügen

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md: .modal-content
            header.modal-header
                h5.modal-title Neuen Benutzer hinzufügen
                button.close(type="button", @click="showModal = false") &times;

            .modal-body
                .form-group
                    label Benutzername
                    input.form-control(
                        v-model="username",
                        :class="{ 'is-invalid': failed.usernameExists || failed.username }",
                        required
                    )
                    small.form-text.text-muted(v-if="usernameDescription") {{ usernameDescription }}
                    .invalid-feedback(v-if="failed.usernameExists") Dieser Benutzername ist bereits vergeben
                    .invalid-feedback(v-else-if="failed.username") Bitte geben Sie einen gültigen Benutzernamen an
                .form-group
                    label Passwort
                    .input-group(:class="{ 'is-invalid': failed.password }")
                        input.form-control(:type="showPassword ? 'text' : 'password'", v-model="password", required)
                        .input-group-append
                            button.btn.btn-light(type="button", @click="showPassword = !showPassword")
                                font-awesome-icon(:icon="showPassword ? 'eye' : 'eye-slash'")
                    .invalid-feedback Bitte geben Sie ein mindestens 6-stelliges Passwort an

            footer.modal-footer
                button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                button.btn.btn-primary(type="button", @click="createAndClose") Benutzer hinzufügen
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { emailRegex } from '@/constants'
import { userService } from '@/services'

library.add(faPlus)

export default {
    data: function () {
        return {
            username: '',
            password: '',
            showModal: false,
            showPassword: false,
            failed: {
                username: false,
                usernameExists: false,
                password: false
            }
        }
    },
    computed: {
        usernameDescription () {
            if (this.username && !this.username.match(emailRegex)) {
                return `Ist der Benutzername keine gültige E-Mail-Adresse, wird ihm eine zu Ihrem Account gehörende Kennung vorangestellt: ${this.$store.getters.accountHash}/${this.username}`
            }
            return ''
        },
        accountActive () {
            return this.$store.getters.accountActive
        }
    },
    methods: {
        async createAndClose () {
            // Reset Validation
            this.failed = {
                username: false,
                usernameExists: false,
                password: false
            }

            // Validate Local
            if (!this.username) {
                this.failed.username = true
            }
            if (!this.password || this.password.length < 6) {
                this.failed.password = true
            }
            if (this.failed.username || this.failed.password) {
                return
            }

            // Prefix Username, if its not an E-Mail
            let username = this.username
            if (!this.username.match(emailRegex)) {
                username = this.$store.getters.accountHash + '/' + this.username
            }

            // Validate via API
            try {
                const res = await userService.validate({ username })
                if (res.username !== 'OK') {
                    this.failed.usernameExists = true
                }
            } catch (err) {
                this.failed.username = true
            }
            if (this.failed.username || this.failed.usernameExists || this.failed.password) {
                return
            }

            try {
                await userService.create({
                    username, // local (with prefixed hash)
                    password: this.password
                })
                this.$store.dispatch('alert/success', 'Benutzer erfolgreich hinzugefügt')
                this.$emit('created')
            } catch (error) {
                this.$store.dispatch('alert/error', 'Benutzer konnten nicht hinzugefügt werden (' + error.message + ')')
            }

            // Cleanup
            this.username = ''
            this.password = ''
            this.showModal = false
        }
    }
}
</script>
